import React from 'react';
export function ActivationReminderTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-43">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-44">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-45" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-46">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-47">
          Reminder: Activate your account
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-48">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-49">
          We noticed you signed up for Aisco Workspace but haven't activated
          your account yet. Don't miss out on everything we have prepared for
          you!
        </p>

        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '32px'
      }} data-id="element-50">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1e40af',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-51">
            By activating your account you'll be able to:
          </h3>
          <ul style={{
          margin: '0',
          paddingLeft: '20px',
          color: '#4b5563',
          fontSize: '14px',
          lineHeight: '1.8'
        }} data-id="element-52">
            <li data-id="element-53">Access all features</li>
            <li data-id="element-54">Manage your projects efficiently</li>
            <li data-id="element-55">Collaborate with your team</li>
            <li data-id="element-56">Save your personalized preferences</li>
          </ul>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-57">
          Your activation link will be available for{' '}
          <strong data-id="element-58">7 more days</strong>. Activate your account now:
        </p>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-59">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-60">
            Activate my account now
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0'
      }} data-id="element-61">
          If you didn't create this account, you can safely ignore this message.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-62">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-63">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-64" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}